// extracted by mini-css-extract-plugin
export default {"getNewCode":"ConfirmCounter_getNewCode__K5Jzs","time":"ConfirmCounter_time__acMu9"};